import { TFunction } from "i18next";
import { Link } from "react-router-dom";

import {
  Badge,
  Button,
  InputText,
  Select,
  Text,
  UserInfoCard,
} from "@pentabd/ui";

import { capitalizeFirstLetter } from "@utils/capitalize";
import { useLanguage } from "@hooks/useLanguage";
import {
  IconChevronDown,
  IconUpload01,
  IconUpload02,
  IconUploadCloud01,
} from "@pentabd/icons";

export const SelectProductsTableColumn = (
  t: TFunction<"translation", undefined>,
  selectProductHandler: (data: any) => void,
  selectedProduct: any,
) => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      key: "category",
      name: t(
        "PROCUREMENT_DEMAND.DEMAND_CREATE.SELECT_PRODUCT_TABLE.COLUMN.CATEGORY",
      ),
      render: (category: string, row: any) => {
        return (
          <Text color="subtitle1" className="text-nowrap">
            {row?.group?.category?.name}
          </Text>
        );
      },
    },
    {
      id: 2,
      key: "group",
      name: t(
        "PROCUREMENT_DEMAND.DEMAND_CREATE.SELECT_PRODUCT_TABLE.COLUMN.GROUP",
      ),
      render: (group: any, row: any) => {
        return (
          <Text color="subtitle1" className="text-nowrap">
            {group?.name || ""}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "brand",
      name: t(
        "PROCUREMENT_DEMAND.DEMAND_CREATE.SELECT_PRODUCT_TABLE.COLUMN.BRAND",
      ),
      render: (brand: any, row: any) => {
        return (
          <Text color="subtitle1" className="text-nowrap">
            {brand?.name || ""}
          </Text>
        );
      },
    },
    {
      id: 4,
      key: "nameEn",
      name: t(
        "PROCUREMENT_DEMAND.DEMAND_CREATE.SELECT_PRODUCT_TABLE.COLUMN.ASSET_NAME",
      ),
      render: (nameEn: string, row: any) => {
        return (
          <Text color="subtitle1" className="text-nowrap">
            {nameEn}
          </Text>
        );
      },
    },
    {
      id: 5,
      key: "isAsset",
      name: t(
        "PROCUREMENT_DEMAND.DEMAND_CREATE.SELECT_PRODUCT_TABLE.COLUMN.IS_ASSET",
      ),
      render: (isAsset: boolean) => {
        return (
          <Text color="subtitle1" className="text-nowrap">
            {isAsset ? "Asset" : "Item"}
          </Text>
        );
      },
    },
    {
      id: 6,
      key: "action",
      render: (action: any, row: any) => {
        return (
          <div className="d-flex justify-content-end">
            <Button
              fill="fill"
              type="primary"
              size="xs"
              className="me-5"
              onClick={() => selectProductHandler(row)}
              disabled={selectedProduct?.some(
                (item: any) => item.id === row.id,
              )}
            >
              {t(
                "PROCUREMENT_DEMAND.DEMAND_CREATE.SELECT_PRODUCT_TABLE.COLUMN.SELECT_BUTTON",
              )}
            </Button>
          </div>
        );
      },
    },
  ];
};
